import React from 'react';

const OrganHealthOverview = ({ data = [] }) => {
  const organs = [
    { name: 'Brain', icon: '🧠', key: 'brain' },
    { name: 'Heart', icon: '❤️', key: 'heart' },
    { name: 'Liver', icon: '🟢', key: 'liver' },
    { name: 'Lungs', icon: '🫁', key: 'lung' },
    { name: 'Stomach', icon: '🟡', key: 'stomach' }
  ];

  // Convert array to object for easier lookup
  const organDataMap = Array.isArray(data) 
    ? data.reduce((acc, organ) => {
        const key = organ.organ_name?.toLowerCase() || organ.name?.toLowerCase() || 'unknown';
        acc[key] = organ;
        return acc;
      }, {})
    : data;

  const getHealthColor = (score) => {
    if (score >= 80) return 'text-green-600';
    if (score >= 60) return 'text-yellow-600';
    if (score >= 40) return 'text-orange-600';
    return 'text-red-600';
  };

  const getHealthText = (score) => {
    if (score >= 80) return 'Excellent';
    if (score >= 60) return 'Good';
    if (score >= 40) return 'Fair';
    return 'Needs Attention';
  };

  const getHealthDescription = (score) => {
    if (score >= 80) return 'Your organ health is excellent. Keep maintaining your healthy lifestyle!';
    if (score >= 60) return 'Good progress! Small improvements can boost your organ health further.';
    if (score >= 40) return 'Your organ needs attention. Consider healthier habits and regular check-ins.';
    return 'Immediate attention needed. Focus on detox and healthy lifestyle changes.';
  };

  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {organs.map((organ) => {
          const organData = organDataMap[organ.key];
          const healthScore = organData?.health_score || 0;
          const healthColor = getHealthColor(healthScore);
          const healthText = getHealthText(healthScore);
          
          return (
            <div key={organ.key} className="text-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
              <div className="text-3xl mb-2">{organ.icon}</div>
              <h4 className="font-semibold text-gray-900 mb-1">{organ.name}</h4>
              <div className={`text-2xl font-bold ${healthColor} mb-1`}>
                {healthScore}%
              </div>
              <p className={`text-sm ${healthColor}`}>
                {healthText}
              </p>
            </div>
          );
        })}
      </div>
      
      {/* Helpful Information Below */}
      <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-100">
        <h4 className="font-semibold text-blue-800 mb-2">💡 Health Insights</h4>
        <p className="text-sm text-blue-700 leading-relaxed">
          Your organ health scores are calculated based on your daily check-ins and lifestyle habits. 
          Regular detox activities, healthy eating, and consistent sleep patterns can improve these scores over time. 
          Complete daily check-ins to track your progress and receive personalized recommendations.
        </p>
      </div>
    </div>
  );
};

export default OrganHealthOverview;
